import { render, staticRenderFns } from "./allocationOrderIn.vue?vue&type=template&id=65bcc060&scoped=true"
import script from "./allocationOrderIn.vue?vue&type=script&lang=js"
export * from "./allocationOrderIn.vue?vue&type=script&lang=js"
import style0 from "./allocationOrderIn.vue?vue&type=style&index=0&id=65bcc060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bcc060",
  null
  
)

export default component.exports